var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 250,
    viewBox: "0 0 258 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2987_13462)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2987_13462)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 250,
    rx: 125,
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.922 148.374C235.922 235.635 162.738 306.375 72.4612 306.375C-17.8159 306.375 -91 235.635 -91 148.374C-91 61.1114 -17.8159 -9.62784 72.4612 -9.62784C162.738 -9.62784 235.922 61.1114 235.922 148.374Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.125 210.242H150.709V142.608H-2.125V210.242Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.896 176.429C116.896 195.103 132.035 210.242 150.71 210.242C169.385 210.242 184.524 195.103 184.524 176.429C184.524 157.754 169.385 142.615 150.71 142.615C132.035 142.615 116.896 157.754 116.896 176.429Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.9395 176.429C-35.9395 195.103 -20.8006 210.242 -2.12642 210.242C16.5485 210.242 31.6874 195.103 31.6874 176.429C31.6874 157.754 16.5485 142.615 -2.12642 142.615C-20.8006 142.615 -35.9395 157.754 -35.9395 176.429Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6094 142.614C96.6094 157.553 108.721 169.664 123.66 169.664C138.6 169.664 150.711 157.553 150.711 142.614C150.711 127.675 138.6 115.563 123.66 115.563C108.721 115.563 96.6094 127.675 96.6094 142.614Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02539 142.61C2.02539 152.02 9.65366 159.648 19.0638 159.648C28.474 159.648 36.103 152.02 36.103 142.61C36.103 133.2 28.474 125.572 19.0638 125.572C9.65366 125.572 2.02539 133.2 2.02539 142.61Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.291 123.679C12.291 151.69 34.9989 174.398 63.0106 174.398C91.023 174.398 113.731 151.69 113.731 123.679C113.731 95.6665 91.023 72.9586 63.0106 72.9586C34.9989 72.9586 12.291 95.6665 12.291 123.679Z",
    fill: "#E7E5E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.12527 214.98V214.585C-12.6459 214.585 -22.1825 210.307 -29.0935 203.396C-36.0039 196.486 -40.2824 186.949 -40.2824 176.428C-40.2832 155.412 -23.2013 138.307 -2.19398 138.27L-1.87804 138.269L-1.80934 137.961C-0.56929 132.375 2.86809 127.5 7.76193 124.458L7.95071 124.341L7.94834 124.119C7.94676 123.971 7.94597 123.825 7.94597 123.679C7.94676 108.497 14.1209 94.7333 24.0927 84.7608C34.0652 74.7891 47.8289 68.6149 63.0104 68.6149C88.9874 68.6141 111.175 86.7362 116.729 111.588L116.813 111.968L117.196 111.888C119.309 111.443 121.469 111.22 123.661 111.22C139.467 111.219 152.585 122.964 154.744 138.183L154.787 138.485L155.09 138.52C174.074 140.698 188.871 156.869 188.869 176.428C188.869 186.949 184.59 196.486 177.68 203.396C170.77 210.307 161.232 214.585 150.712 214.585H-2.12527V214.98V215.375H150.712C172.188 215.374 189.658 197.905 189.66 176.428C189.658 156.462 174.561 139.96 155.18 137.735L155.136 138.128L155.526 138.072C153.312 122.466 139.867 110.431 123.661 110.43C121.415 110.43 119.2 110.659 117.033 111.115L117.114 111.502L117.5 111.416C111.865 86.2039 89.361 67.8251 63.0104 67.8251C32.2114 67.8259 7.15692 92.8796 7.15613 123.679C7.15613 123.827 7.15692 123.976 7.1585 124.127L7.55342 124.123L7.34489 123.788C2.27018 126.941 -1.29436 131.997 -2.58022 137.79L-2.19477 137.875L-2.19556 137.48C-23.6397 137.52 -41.0715 154.974 -41.0723 176.428C-41.0715 197.905 -23.6018 215.374 -2.12527 215.375V214.98Z",
    fill: "#D6D3D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.401 85.9453L72.1094 174.406L104.776 197.185L198.528 143.518L135.401 85.9453Z",
    fill: "url(#paint0_linear_2987_13462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.576 86.7552V135.117C201.576 141.475 197.107 146.625 191.596 146.625H137.732C132.221 146.625 127.752 141.475 127.752 135.117V73.0594C127.752 66.7011 132.221 61.5514 137.732 61.5514H179.703L196.209 80.5707L201.576 86.7552Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.576 86.8203H188.926C183.832 86.8203 179.703 82.0623 179.703 76.193V61.6165L201.576 86.8203Z",
    fill: "#D2F0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 94.5C158.112 94.5 152.5 100.112 152.5 107C152.5 113.888 158.112 119.5 165 119.5C171.888 119.5 177.5 113.888 177.5 107C177.5 100.112 171.888 94.5 165 94.5ZM170.975 104.125L163.887 111.212C163.712 111.388 163.475 111.487 163.225 111.487C162.975 111.487 162.738 111.388 162.562 111.212L159.025 107.675C158.662 107.312 158.662 106.712 159.025 106.35C159.387 105.987 159.987 105.987 160.35 106.35L163.225 109.225L169.65 102.8C170.013 102.438 170.613 102.438 170.975 102.8C171.338 103.163 171.338 103.75 170.975 104.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9219 165V211H51.9219V165H83.9219Z",
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.455 138.687L40.3783 169.818C39.3248 171.076 40.2119 173 41.8452 173H93.9985C95.6318 173 96.519 171.076 95.4654 169.818L69.3887 138.687C68.622 137.771 67.2218 137.771 66.455 138.687Z",
    fill: "#16A34A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2987_13462",
    x: 0,
    y: 0,
    width: 258,
    height: 250,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2987_13462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2987_13462",
    x1: 165.209,
    y1: 105.308,
    x2: 101.939,
    y2: 192.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2987_13462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 250,
    rx: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCloud);
export default __webpack_public_path__ + "static/media/successCloud.d0b559767b73525313148ce19603cf9c.svg";
export { ForwardRef as ReactComponent };